export default {
    userinfo:'/userinfo/index',


    upload:'/upload/index',
    uploadEditor:'/upload/editor',
    uploadEditorVideo:'/upload/editorVideo',

    login:'/login/index',
    adminList:'/admin/index',
    adminTotal:'/admin/total',
    adminAdd:'/admin/add',
    adminEdit:'/admin/edit',
    adminRoleOptions:'/admin/roleoptions',
    adminDelete:'/admin/delete',
    adminLogList:'/admin/loglist',
    adminLogTotal:'/admin/logtotal',

    adminRoleList:'/admin_role/index',
    adminRoleAdd:'/admin_role/add',
    adminRoleEdit:'/admin_role/edit',
    adminRoleDelete:'/admin_role/delete',

    

    articleList:'/article/index',
    articleFocos:'/article/focos',
    articleAuditApply:'/article/audit_apply',
    articleAuditLog:'/article/audit_log',
    articleDelete:'/article/delete',
    articleAdd:'/article/add',
    articleEdit:'/article/edit',
    articleTypeList:'/article/type_list',
    articleKeywordList:'/article/keywordlist',

}
